import { render } from "./WorkOrderList.vue?vue&type=template&id=bcda278a&scoped=true"
import script from "./WorkOrderList.vue?vue&type=script&lang=js"
export * from "./WorkOrderList.vue?vue&type=script&lang=js"

import "./WorkOrderList.vue?vue&type=style&index=0&id=bcda278a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bcda278a"]])

export default __exports__